import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCliente } from "../context/ClienteContext";
import { menuAdminCliente } from "../components/sidebarMenus/menuAdminCliente";
import { menuCoordenador } from "../components/sidebarMenus/menuCoordenador";
import { menuProfessor } from "../components/sidebarMenus/menuProfessor";

const TemplateCliente = ({ children }) => {
  const navigate = useNavigate();
  const { parametros, nomeCliente } = useCliente();
  if (!parametros) return null;
  const tipoUsuario = localStorage.getItem("tipo");
  const clienteId = localStorage.getItem("cliente_id");
  const nomeUsuario = localStorage.getItem("nome");


  const handleLogout = () => {
    navigate("/");
  };

  if (!parametros) {
    return <div>Carregando interface personalizada...</div>;
  }

  // 🔁 Mapeamento de valores amigáveis para internos
  const mapTipoUsuario = {
    "administrador do cliente": "admin_cliente",
    "coordenador": "coordenador",
    "professor": "professor"
  };

  const tipoPadronizado = mapTipoUsuario[tipoUsuario?.toLowerCase().trim()] || "";

  const obterMenuPorPerfil = (tipo) => {
    if (tipo === "admin_cliente") return menuAdminCliente;
    if (tipo === "coordenador") return menuCoordenador;
    if (tipo === "professor") return menuProfessor;
    return [];
  };

  const menuSidebar = obterMenuPorPerfil(tipoPadronizado);

  return (
    <div className="template-container" style={{ backgroundColor: parametros.cor_fundo_principal }}>
      <header className="header" style={{ backgroundColor: parametros.cor_cabecalho }}>
        <div className="logo">
          <img
            src={parametros.logo_url}
            alt="Logo do Cliente"
            style={{
              maxWidth: "200px",
              maxHeight: "85px",
              height: "auto",
              width: "auto",
              objectFit: "contain"
            }}
          />
        </div>

        <div className="header-title" style={{ color: parametros.cor_texto_secundario }}>
          {nomeCliente}
        </div>

        <div style={{
          marginLeft: "auto",
          marginRight: "15px",
          display: "flex",
          alignItems: "center",
          gap: "1.5rem"
        }}>
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center",
            color: parametros.cor_texto_secundario,
            fontSize: "0.75rem"
          }}>
            <span>{nomeUsuario}</span>
            <span style={{ fontSize: "0.6rem", opacity: 0.8 }}>{tipoUsuario}</span>
          </div>

          <button className="logout-btn" onClick={handleLogout}>logout</button>
        </div>

      </header>

      <div className="layout">
        <nav className="sidebar" style={{ backgroundColor: parametros.cor_sidebar, marginLeft: "-4px" }}>
          <ul>
            {menuSidebar.map((item) => (
              <li key={item.path}>
                <Link to={item.path} style={{ color: parametros.cor_texto_secundario }}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <main
          className="content"
          style={{
            backgroundColor: parametros.cor_fundo_principal,
            width: "1080px",
            margin: "0 auto",
            position: "relative",
            zIndex: 0
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default TemplateCliente;

